import { useState } from 'react';
import Button from '@creditflowresearch/uilib/Button';
import IconSparkle from '@creditflowresearch/uilib/Icon/IconSparkle';
import IconSparkleGradient from '@creditflowresearch/uilib/Icon/IconSparkleGradient';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { useAiSidebarContext } from '@/creditflowresearch/application/AiSidebar/AiSidebarContext';
import AskAiNoAccessTooltip from './AskAiNoAccessTooltip';

import styles from './askAiButton.module.scss';

const AskAiButton = (): React.ReactElement => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const { isOpen, toggle } = useAiSidebarContext();
  const { checkAccessByUserPlan } = useUserPlanContext();
  const hasAccess = checkAccessByUserPlan(UserPlanType.PREMIUM);
  const Sparkle = hasAccess ? IconSparkleGradient : IconSparkle;

  return (
    <div
      className={ styles.container }
      onMouseEnter={ () => setIsTooltipVisible(true) }
      onMouseLeave={ () => setIsTooltipVisible(false) }
    >
      <Button
        variant="outline"
        size="M"
        icon={ <Sparkle className={ styles.icon } /> }
        onClick={ toggle }
        disabled={ !hasAccess }
        aria-expanded={ isOpen }
        className={ styles.button }
        childrenClassName={ hasAccess ? styles.label : undefined }
        dataTest="askAiButton"
      >
        Ask AI
      </Button>
      { !hasAccess && isTooltipVisible && <AskAiNoAccessTooltip /> }
    </div>
  );
};

export default AskAiButton;
